module.exports = __webpack_public_path__ + "media/assets/images/marker-b65d70fa763c273f7ccbb333b593c614.svg";